
<f-dialog
    :title  = "entry.type.name"
    v-model = "value"
    :width  = "460"
    @cancel = "onCancel"
    @store  = "onSave"
>
    <template v-slot:content>
        <crm-entry-edit
            :entry    = "entry"
            :incident = "incident"
            class     = "mb-1"
            ref       = "editor"
            @saved    = "onSaved"
        />
    </template>
</f-dialog>
